/** Lifecycle einer Session. Reihenfolge = erwarteter Verlauf. */
export const SESSION_STATES = [
    'pending',
    'starting',
    'joining',
    'lobby',
    'active',
    'leaving',
    'ended',
    'failed',
];
/** Zustaende, aus denen es kein Zurueck gibt. */
export const TERMINAL_SESSION_STATES = ['ended', 'failed'];
export function isTerminalState(state) {
    return TERMINAL_SESSION_STATES.includes(state);
}
export function isActiveState(state) {
    return !isTerminalState(state);
}
/**
 * Erlaubte Uebergaenge. Wird von der Control Plane erzwungen, damit ein
 * verspaeteter Worker-Report keine beendete Session wieder "aktiv" macht.
 */
export const SESSION_TRANSITIONS = {
    pending: ['starting', 'failed', 'ended'],
    starting: ['joining', 'failed', 'leaving', 'ended'],
    joining: ['lobby', 'active', 'failed', 'leaving'],
    lobby: ['active', 'failed', 'leaving'],
    active: ['leaving', 'failed', 'ended'],
    leaving: ['ended', 'failed'],
    ended: [],
    failed: [],
};
export function canTransition(from, to) {
    return SESSION_TRANSITIONS[from].includes(to);
}
/** Kurzlabel fuer die UI. */
export const SESSION_STATE_LABELS = {
    pending: 'Wartet',
    starting: 'Startet',
    joining: 'Tritt bei',
    lobby: 'In der Lobby',
    active: 'Aktiv',
    leaving: 'Verlaesst',
    ended: 'Beendet',
    failed: 'Fehlgeschlagen',
};
/**
 * Erklaerungstext pro Zustand. Vor allem `lobby` muss in der UI eindeutig sein,
 * sonst suchen Mitarbeiter den Fehler im System statt im Meeting.
 */
export const SESSION_STATE_HINTS = {
    pending: 'Session ist angelegt und wartet auf einen freien Slot.',
    starting: 'Worker-Container wird gestartet, Chrome und AVA laden.',
    joining: 'Verbindung zum Teams-Meeting wird aufgebaut.',
    lobby: 'Teams haelt AVA in der Lobby — bitte im Meeting zulassen.',
    active: 'AVA ist im Meeting, Audio und Video laufen.',
    leaving: 'AVA verlaesst das Meeting.',
    ended: 'Session ist regulaer beendet.',
    failed: 'Session wurde abgebrochen. Details siehe Fehlermeldung.',
};
export const SESSION_END_REASON_LABELS = {
    user_requested: 'Manuell gestoppt',
    auto_leave_timeout: 'Auto-Leave: Zeitlimit erreicht',
    alone_in_meeting: 'Auto-Leave: AVA war allein im Meeting',
    join_timeout: 'Beitritt kam nicht zustande',
    lobby_timeout: 'Niemand hat AVA aus der Lobby zugelassen',
    removed_from_meeting: 'Aus dem Meeting entfernt',
    worker_crashed: 'Worker-Container abgestuerzt',
    orphan_cleanup: 'Verwaiste Session beim Neustart aufgeraeumt',
    shutdown: 'Service wurde beendet',
};
/**
 * Welche beendeten Sessions einen erneuten Beitritt anbieten.
 *
 * Nur die juengsten, weil ein Meeting-Link altert: ein Monate alter Termin
 * fuehrt zu einem Beitritt, der scheitert, und ein Knopf, der verlaesslich
 * scheitert, ist schlechter als keiner.
 *
 * Sortiert wird hier selbst nach Ende (ersatzweise Anlage), statt sich auf die
 * Reihenfolge der Liste zu verlassen - die kommt aus einer Abfrage, und deren
 * Sortierung kann sich aendern, ohne dass es hier auffaellt.
 */
export function rejoinableSessions(sessions, limit = 5) {
    return sessions
        .filter((session) => isTerminalState(session.state))
        .slice()
        .sort((a, b) => Date.parse(b.endedAt ?? b.createdAt) - Date.parse(a.endedAt ?? a.createdAt))
        .slice(0, Math.max(0, limit));
}
//# sourceMappingURL=session.js.map